export const SPEED = 300;
export const WINW = window.screen.width;
export const WINH = window.screen.height;
export const MOVEOFFSET = 10;
export const KEYBOARDMOVEOFFSET = 20;
